import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import {
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  LabelSMBoxStyle,
  HtmlTooltip,
  ContentStyle,
  DRxSelectStyle,
  DRxInputStyle,
} from "../../../Theme";
import { useLocation, useNavigate } from "react-router";
import { DialogPopup } from "../../../components/DialogPopup";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { PatientInfoCard } from "../../../components/Content";
import { HelpGuideTooltip } from "../../../components/HelpGuideTooltip";
import DRxInput from "../../../uikit/DRxInput";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import {
  RefillAlertsDetails,
  RefillAlertsReplace,
  RefillAlertsSendToPharmacy,
} from "../../../Apis/AuthApiServices";
import { useDispatch, useSelector } from "react-redux";
import DrugNotMatchPopUp from "../../../components/DrugNotMatchPopUp";
import PatientNotMatchPopUp from "../../../components/PatientNotMatchPopUp";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { loadingPharmacyDropDown } from "../../../Redux/Slice/PharmacyDropDownSlice";
import YSCheckBox from "../../../uikit/YSCheckBox";
import { EpaPrescriptionDetails } from "../../PendingRefillsRequest";

const initialStateReFillAlertRequest = {
  drugId: "",
  personId: "",
  drugName: "",
  drugType: "",
  strength: "",
  strengthUnit: "",
  route: "",
  formularyStatus: "",
  copay: "",
  coverage: "",
  sig: "",
  dosageForm: "",
  daysSupply: null,
  packSizeUnitCode: "",
  quantity: null,
  quantityQualifier: "",
  instructions: "",
  substitutionCode: "",
  substitutions: "",
  pickupDateTime: null,
  doctorId: "",
  pharmacyId: "",
  pharmacyName: "",
  pharmacyPhone: "",
  pharmacyFaxNumber: "",
  pharmacyAddress: "",
  createdDate: "",
  refills: null,
  rxHubPBMUniqueId: "",
  rxMessageNumber: "",
  tentativeEndDt: null,
  description: null,
  dispensibleDrugId: null,
  deprectedQualifier: null,
  doctorNote: "",
  codifiedSig: "",
  dailyMaxDose: "",
  wcxfrIndicator: "",
  refillType: "",
  primaryRxNDC: "",
  diagnosisIcd: "",
  paRequired: null,
  paPrioritize: null,
  doctorFirstName: "",
  doctorLastName: "",
  activeFlag: null,
  reasonDenied: "",
  rxSSMsgNumber: "",
  rxAlertId: "",
  rxId: "",
  alertDescription: "",
  alertDate: "",
  messageId: "",
  refillsQualifier: "",
  writtenDate: "",
  doctorIdentificationNumber: "",
  patientFirstName: "",
  patientLastName: "",
  patientGender: "",
  patientDateOfBirth: "",
  lastFilledDate: "",
  status: "",
  patientAddressLine1: "",
  patientPhone: "",
  pharmacyType: "",
  pharmacyNote: null,
  pharmacyCity: "",
  pharmacyZip: "",
  pharmacyState: "",
  rxNorm: "",
  ddid: "",
  scheduledDrug: null,
  initiateEpa: false,
};

export default function PendingRefillAlertsRequest(props: any) {
  const location: any = useLocation();
  const dispatch = useDispatch();
  const [RefillRequestData, setRefillRequestData] = useState<any>(
    initialStateReFillAlertRequest
  );
  const [matchingList, setMatchingList] = useState(false);
  const [loader, setLoader] = useState(true);
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [sendToPharmacyData, setSendToPharmacyData] = useState([]);
  const [smallLoad, setSmallLoad] = useState(false);
  const [smallLoad2, setSmallLoad2] = useState(false);

  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const getValuesOfDropDown = () => {
    let SubValue: any = AllDropdwonsState?.substitutionCodeOptions.find(
      (i: any) => i.id === RefillRequestData?.substitutionCode ?? {}
    );
    setRefillRequestData({
      ...RefillRequestData,
      substitutions: SubValue.description,
    });
  };

  const [DrugNotMatchPopup, setDrugNotMatchPopup] = useState(false);
  const handleShowDrugNotMatchPopupClick = () => {
    setDrugNotMatchPopup(true);
  };
  const handleHideDrugNotMatchPopupClick = () => {
    setDrugNotMatchPopup(false);
  };
  const [PatientNotMatchPopup, setPatientNotMatchPopup] = useState(false);
  const handleShowPatientNotMatchPopupClick = () => {
    setPatientNotMatchPopup(true);
  };
  const handleHidePatientNotMatchPopupClick = () => {
    setPatientNotMatchPopup(false);
  };

  const navigate = useNavigate();
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    setApprovedPopup(false);
    navigate("/pendingrefillsalert");
  };

  const history = useNavigate();

  const handleBackClick = () => {
    history("/pendingrefillsalert");
  };

  // useEffect(() => {
  //   if (RefillRequestData?.patientMismatchPopupFlag) {
  //     handleShowPatientNotMatchPopupClick();
  //   } else if (RefillRequestData?.drugMismatchPopupFlag) {
  //     handleShowDrugNotMatchPopupClick();
  //   }
  // }, [RefillRequestData]);

  const getReFillAlertsDetails = async () => {
    try {
      const params: any = new URLSearchParams();
      params.append("doctorId", location?.state?.rowData?.doctorId);
      params.append("messageId", location?.state?.rowData?.messageId);
      params.append("selectedClinicId", sessionStorage.getItem("clinicId"));
      const result = await RefillAlertsDetails(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setRefillRequestData({
          ...result?.data?.response[0],
          reasonDenied: "0",
          initiateEpa: true,
        });
        if (result?.data?.response[0]?.patientMismatchPopupFlag) {
          handleShowPatientNotMatchPopupClick();
        } else if (result?.data?.response[0]?.drugMismatchPopupFlag) {
          handleShowDrugNotMatchPopupClick();
        }
        getValuesOfDropDown();
      } else {
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    getReFillAlertsDetails();
  }, []);

  const gotoSendToPharmacy = async (values: any, ACTION: any) => {
    try {
      setSmallLoad(ACTION === "APPROVED" ? true : false);
      setSmallLoad2(ACTION === "DENIED" ? true : false);
      const bodyData = {
        doctorId: localStorage.getItem("doctorId"),
        prescriberAgentId: values?.doctorId,
        messageId: values?.messageId,
        notes: values?.doctorNote,
        refillAction: ACTION,
        denialReason: values?.reasonDenied === "0" ? "" : values?.reasonDenied,
        refillCount: parseInt(values?.refills),
        selectedAddress: sessionStorage.getItem("clinicId"),
        matchingPatientId: values?.personId,
        matchingPatientFoundFlag: RefillRequestData?.patientMismatchPopupFlag
          ? "1"
          : "0",
        matchingDrugFoundFlag: RefillRequestData?.drugMismatchPopupFlag
          ? "1"
          : "0",
        matchingDrugId: "",
      };
      const params = new URLSearchParams();
      params.append(
        "paInitiationFlag",
        RefillRequestData?.epaPrescription &&
          RefillRequestData?.epaAuthValid === false
          ? values?.initiateEpa
          : "false"
      );
      const result = await RefillAlertsSendToPharmacy(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        handleShowApprovedPopupClick();
        setSendToPharmacyData(result?.data?.response);
        dispatch(loadingTopRibbon());
        setSmallLoad(false);
        setSmallLoad2(false);
      } else {
        setSendToPharmacyData([]);
        setSmallLoad(false);
        setSmallLoad2(false);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setSendToPharmacyData([]);
      setSmallLoad(false);
      setSmallLoad2(false);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const [replaceLoader, setReplaceLoader] = useState(false);
  const getRefillAlertsReplace = async () => {
    try {
      setReplaceLoader(true);
      const bodyData = {
        refillAlertId: location?.state?.rowData?.rxAlertId,
        patientId: RefillRequestData?.personId,
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: location?.state?.rowData?.doctorId,
          onBehalfDoctorId: "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await RefillAlertsReplace(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReplaceLoader(false);
        sessionStorage.setItem("patientId", RefillRequestData?.personId);
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response)
        );
        sessionStorage.setItem(
          "rxHubOptions",
          JSON.stringify(result?.data?.response[0]?.rxhubPBMUniqueIdOptions)
        );
        sessionStorage.setItem(
          "rxhubPBMUniqueId",
          result?.data?.response[0]?.rxhubPBMUniqueId
        );
        dispatch(loadingPharmacyDropDown());
        navigate("/newrxpad");
      } else {
        setReplaceLoader(false);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setReplaceLoader(false);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Pending Refill Alerts{" "}
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  Refill-related alerts resulting from data discrepancies
                </Typography>
              </>
            }
            pdf={"#"}
            video={"#"}
          />
        </Typography>
        {loader ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Formik
            initialValues={RefillRequestData}
            enableReinitialize={true}
            onSubmit={(values) => {
              if (
                !RefillRequestData?.patientMismatchPopupFlag ||
                matchingList
              ) {
                gotoSendToPharmacy(values, "APPROVED");
              } else {
                setStateData((prevState: any) => {
                  return {
                    ...prevState,
                    message:
                      "Please Select patient mismatch from patient mismatch",
                    variant: "error",
                    open: true,
                  };
                });
                handleShowPatientNotMatchPopupClick();
              }
            }}
          >
            {(registerProps) => (
              <Form onSubmit={registerProps.handleSubmit}>
                <PatientInfoCard
                  name={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.name
                    //   :
                    RefillRequestData?.patientFirstName +
                    " " +
                    RefillRequestData?.patientLastName
                  }
                  patientId={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.personId
                    //   :
                    RefillRequestData?.personId
                  }
                  age={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.age
                    //   :
                    RefillRequestData?.age
                  }
                  telePhone={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]
                    //       ?.homeTelephone
                    //   :
                    RefillRequestData?.patientPhone
                  }
                  address={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.address
                    //   :
                    RefillRequestData?.patientAddressLine1
                  }
                  ssn={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.ssn
                    //   :
                    RefillRequestData?.patientSocialSecurityNumber
                  }
                  dateOfBirth={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.dateOfBirth
                    //   :
                    RefillRequestData?.patientDateOfBirth
                  }
                  gender={
                    // matchingList
                    //   ? RefillRequestData?.matchingPatientsList[0]?.gender
                    //   :
                    RefillRequestData?.patientGender
                  }
                />

                <Grid
                  container
                  item
                  xs={12}
                  spacing={0}
                  alignItems="top"
                  justifyContent="space-between"
                  columnSpacing={5}
                >
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="writtendate"
                      >
                        Written Date
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="writtendate"
                            name="writtenDate"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.writtenDate}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="lastfilleddate"
                      >
                        Last Filled Date
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="lastfilleddate"
                            name="lastFilledDate"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.lastFilledDate}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="drugdescription"
                      >
                        Drug Description
                      </Typography>{" "}
                      <Box display={{ xs: "flex", sm: "flex", md: "flex" }}>
                        <DRxInputStyle>
                          <DRxInput
                            id="drugdescription"
                            name="description"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.description}
                          />
                          <Typography variant="body2" color="primary">
                            {RefillRequestData?.scheduledDrug
                              ? !RefillRequestData?.medicationDispensedDeaClassCode &&
                                RefillRequestData?.deaClassCode
                                ? RefillRequestData?.medicationPrescribedDeaClassCode &&
                                  RefillRequestData?.medicationPrescribedDeaClassCode ===
                                    RefillRequestData?.deaClassCode
                                  ? `Medication Prescribed is a ${RefillRequestData?.medicationPrescribedDeaClassCode}`
                                  : RefillRequestData?.medicationDispensedDeaClassCode &&
                                    RefillRequestData?.medicationDispensedDeaClassCode ===
                                      RefillRequestData?.deaClassCode
                                  ? `Medication Dispensed is a ${RefillRequestData?.medicationDispensedDeaClassCode}`
                                  : RefillRequestData?.originalPrescriptionDeaClassCode &&
                                    RefillRequestData?.originalPrescriptionDeaClassCode ===
                                      RefillRequestData?.deaClassCode
                                  ? `Original Rx is a ${RefillRequestData?.originalPrescriptionDeaClassCode}`
                                  : RefillRequestData?.deaClassCode
                                : RefillRequestData?.deaClassCode
                              : ""}
                          </Typography>
                        </DRxInputStyle>
                      </Box>{" "}
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography
                          component="label"
                          variant="body1"
                          color={"primary"}
                          fontWeight={600}
                        >
                          Medication Prescribed
                        </Typography>
                        <HtmlTooltip
                          placement="top"
                          arrow
                          title={
                            <PrescribedDrugInfo
                              row={RefillRequestData?.prescribedDrugInfo}
                            />
                          }
                        >
                          <IconButton className="tooltip">
                            <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                          </IconButton>
                        </HtmlTooltip>
                      </Box>
                      {RefillRequestData?.epaPrescription && (
                        <Typography
                          component="div"
                          variant="body2"
                          display={"flex"}
                          flexDirection={"row"}
                          justifyContent={"space-around"}
                          alignItems={"center"}
                        >
                          <Typography
                            bgcolor={
                              RefillRequestData?.epaAuthInValid
                                ? "#fcaca7"
                                : RefillRequestData?.epaPrescription &&
                                  RefillRequestData?.epaAuthValid
                                ? "#82f5a0"
                                : RefillRequestData?.epaPrescription &&
                                  !RefillRequestData?.epaAuthValid &&
                                  "#fccf8b"
                            }
                            component="div"
                            variant="body2"
                            borderRadius={5}
                            paddingX={1}
                            paddingY={0.5}
                            border={
                              RefillRequestData?.epaAuthInValid
                                ? "1px solid red"
                                : RefillRequestData?.epaPrescription &&
                                  RefillRequestData?.epaAuthValid
                                ? "1px solid green"
                                : RefillRequestData?.epaPrescription &&
                                  !RefillRequestData?.epaAuthValid &&
                                  "1px solid orange"
                            }
                          >
                            {RefillRequestData?.epaAuthInValid ? (
                              <>PA Invalid</>
                            ) : RefillRequestData?.epaPrescription &&
                              RefillRequestData?.epaAuthValid ? (
                              <>PA valid</>
                            ) : (
                              RefillRequestData?.epaPrescription &&
                              !RefillRequestData?.epaAuthValid && (
                                <>PA Expired</>
                              )
                            )}
                          </Typography>
                          <HtmlTooltip
                            placement="left"
                            arrow
                            title={
                              <EpaPrescriptionDetails row={RefillRequestData} />
                            }
                            className="w316"
                          >
                            <IconButton className="tooltip">
                              <img
                                src={InfoIcon}
                                alt="Tooltip"
                                loading="lazy"
                              />
                            </IconButton>
                          </HtmlTooltip>
                          {(RefillRequestData?.epaPrescription &&
                            RefillRequestData?.epaAuthValid) === false && (
                            <YSCheckBox
                              name={`initiateEpa`}
                              label={"Initiate EPA"}
                            />
                          )}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="sig"
                      >
                        SIG
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="sig"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.sig}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="DaysSupply"
                      >
                        Days Supply{" "}
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="daysSupply"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.daysSupply}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="Qualifier"
                      >
                        Qualifier{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="quantityQualifier"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.quantityQualifier}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="Quantity"
                      >
                        Quantity{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="quantity"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.quantity}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="Quantity"
                        marginTop={"0 !important"}
                      >
                        Total number of dispensings approved{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="refills"
                            type="number"
                            className=""
                            disabled={false}
                            value={registerProps.values.refills}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>{" "}
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="NoteFromPharmacy"
                        marginTop={"0 !important"}
                      >
                        Note From Pharmacy{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="pharmNote"
                            name="pharmacyNote"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.pharmacyNote}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="Note"
                      >
                        Note
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="note"
                            name="doctorNote"
                            type="text"
                            className=""
                            placeholder="Enter Note"
                            value={registerProps.values.doctorNote}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="substitutionCode"
                      >
                        Substitutions
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="substitutionCode"
                            id="substitutionCode"
                            options={
                              AllDropdwonsState?.substitutionCodeOptions ?? [
                                { label: "", value: "" },
                              ]
                            }
                            disabled={true}
                            label="substitutionCode"
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "substitutionCode",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.substitutionCode}
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        variant="body2"
                        htmlFor="reasonDenied"
                      >
                        Denial Reason
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="reasonDenied"
                            id="reasonDenied"
                            options={
                              AllDropdwonsState?.denialReasonsForRefillsOptions ?? [
                                { value: "", label: "" },
                              ]
                            }
                            label="reasonDenied"
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "reasonDenied",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.reasonDenied}
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LabelSMBoxStyle>
                      <Typography component="label" variant="body2">
                        Pharmacy
                      </Typography>
                      <Box>
                        <Typography
                          component="div"
                          marginTop={1}
                          color="primary"
                          variant="body2"
                        >
                          {RefillRequestData?.pharmacyName}
                          <HtmlTooltip
                            placement="right"
                            arrow
                            title={
                              <PharmacyDetails
                                row={RefillRequestData?.pharmacyDetails}
                              />
                            }
                            className="w316"
                          >
                            <IconButton className="tooltip">
                              <img
                                src={InfoIcon}
                                alt="Tooltip"
                                loading="lazy"
                              />
                            </IconButton>
                          </HtmlTooltip>
                        </Typography>
                      </Box>
                    </LabelSMBoxStyle>
                  </Grid>
                  <Grid item xs={12}>
                    <BtnSMGroupStyle>
                      <YSButton
                        className={""}
                        children={"Back"}
                        onClick={handleBackClick}
                        variant={"outlined"}
                        type={"button"}
                        size={"large"}
                        color="secondary"
                      />
                      <YSButton
                        size="large"
                        className=""
                        color="secondary"
                        dataTestId="submitBtn"
                        variant="outlined"
                        disabled={false}
                        type="button"
                        children={
                          smallLoad2 ? (
                            <CircularProgress color="primary" size={28} />
                          ) : (
                            "Denied"
                          )
                        }
                        onClick={() => {
                          if (
                            !RefillRequestData?.patientMismatchPopupFlag ||
                            matchingList
                          ) {
                            gotoSendToPharmacy(registerProps.values, "DENIED");
                          } else {
                            setStateData((prevState: any) => {
                              return {
                                ...prevState,
                                message:
                                  "Please Select patient mismatch from patient mismatch",
                                variant: "error",
                                open: true,
                              };
                            });
                            handleShowPatientNotMatchPopupClick();
                          }
                        }}
                      />{" "}
                      <YSButton
                        size="large"
                        className=""
                        color="secondary"
                        dataTestId="submitBtn"
                        variant="outlined"
                        disabled={false}
                        type="button"
                        children={
                          replaceLoader ? (
                            <CircularProgress color="primary" size={28} />
                          ) : (
                            "Replace"
                          )
                        }
                        onClick={() => {
                          if (
                            !RefillRequestData?.patientMismatchPopupFlag ||
                            matchingList
                          ) {
                            getRefillAlertsReplace();
                          } else {
                            setStateData((prevState: any) => {
                              return {
                                ...prevState,
                                message:
                                  "Please Select patient mismatch from patient mismatch",
                                variant: "error",
                                open: true,
                              };
                            });
                            handleShowPatientNotMatchPopupClick();
                          }
                        }}
                      />
                      {RefillRequestData?.deprectedQualifier ||
                      RefillRequestData?.scheduledDrug ? null : (
                        <YSButton
                          size="large"
                          className=""
                          color="primary"
                          dataTestId="submitBtn"
                          variant="contained"
                          disabled={false}
                          type="submit"
                          children={
                            smallLoad ? (
                              <CircularProgress color="inherit" size={28} />
                            ) : (
                              "Approved"
                            )
                          }
                        />
                      )}
                    </BtnSMGroupStyle>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <DialogPopup
        title="Prescribed matching medication"
        windowsize={"sm"}
        show={DrugNotMatchPopup}
        handleShowPopupClick={handleShowDrugNotMatchPopupClick}
        handleHidePopupClick={handleHideDrugNotMatchPopupClick}
      >
        <DrugNotMatchPopUp
          matchingDrugList={RefillRequestData?.matchingDrugList}
        />
      </DialogPopup>
      <DialogPopup
        title="Patient Selection"
        windowsize={"md"}
        show={PatientNotMatchPopup}
        handleShowPopupClick={handleShowPatientNotMatchPopupClick}
        handleHidePopupClick={handleHidePatientNotMatchPopupClick}
      >
        <PatientNotMatchPopUp
          RequestData={RefillRequestData}
          setRefillRequestData={setRefillRequestData}
          setMatchingList={setMatchingList}
          handleHidePatientNotMatchPopupClick={
            handleHidePatientNotMatchPopupClick
          }
        />
      </DialogPopup>
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {sendToPharmacyData?.map((each: any) => (
            <>
              <Grid item xs={12} textAlign={"center"} marginTop={1}>
                {each?.status ? (
                  <CheckCircleOutlineIcon
                    style={{ height: 70, width: 70 }}
                    color="success"
                  />
                ) : (
                  <CancelOutlinedIcon
                    style={{ height: 70, width: 70 }}
                    color="error"
                  />
                )}
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Typography
                  color={"primary"}
                  component="span"
                  variant="subtitle1"
                  fontWeight={600}
                >
                  {each?.operation}
                </Typography>{" "}
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Typography component="span" variant="subtitle2">
                  {each?.message}
                </Typography>{" "}
              </Grid>
            </>
          ))}
        </Grid>{" "}
      </DialogPopup>
    </>
  );
}
const PrescribedDrugInfo = (props: any) => {
  const { row } = props;
  return (
    <>
      <Typography component={"div"} variant={"h6"} fontWeight={700}>
        Medication Prescribed
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Drug Name:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.drugDescription)
              ? "Not Available"
              : row?.drugDescription}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Qualifier:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.quantityQualifier)
              ? "Not Available"
              : row.quantityQualifier}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Quantity:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.quantity) ? "Not Available" : row.quantity}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Total no.of dispensing requested:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.refills) ? "Not Available" : row.refills}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Notes:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.notes) ? "Not Available" : row.notes}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Substitution:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.substitution)
              ? "Not Available"
              : row.substitution}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Directions:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.instructions)
              ? "Not Available"
              : row.instructions}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Written Date:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.writtenDate)
              ? "Not Available"
              : row.writtenDate}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.pharmacyName)
            ? "Not Available"
            : row?.pharmacyName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.twentyFourHourFlag)
            ? "Not Available"
            : row?.twentyFourHourFlag}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.storeNo) ? "Not Available" : row?.storeNo}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.pharmacyAddress)
            ? "Not Available"
            : row?.pharmacyAddress}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.landmark) ? "Not Available" : row?.landmark}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.city) ? "Not Available" : row?.city}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.state) ? "Not Available" : row?.state}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.zip) ? "Not Available" : row?.zip}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.pharmacyPhone)
            ? "Not Available"
            : row?.pharmacyPhone}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.faxNo) ? "Not Available" : row?.faxNo}
        </Typography>
      </Grid>
    </Grid>
  );
};
